import React, { useEffect, useMemo, useState, useRef } from 'react';
import { toast as toastEmitter } from 'react-toastify';
import Button from "../Button.jsx";


let toastsCreated = 1;
const toasts = {};
window.toastActionClickedGlobalHelper = (id) => {
	const action = toasts[id];
	if(action) {
		action();
	}
};

/**
 *
 * @param children
 * @param action | onClick, afterClickContent, content
 * @param onDismiss
 * @returns {*}
 * @constructor
 */
export default function ToastCreator({
	                                     children = 'I am Toast', action = null, onDismiss = () => {
	}
                                     }) {

	const [dismissed, updateDismissed] = useState(false);
	const [actionPerformed, updateActionPerformed] = useState(false);
	const toastReference = useRef(null);
	const { toastId } = useMemo(() => {
		return {
			toastId: `toasts_rendered_${toastsCreated++}`,
		};
	}, []);

	function toastActionClickedInnerFunction() {
		if(action.onClick) {
			updateActionPerformed(true);
			action.onClick();
		}
	}

	useEffect(() => {
		toastReference.current = toastEmitter(
			({ closeToast }) => (
				renderToast()
			),
			{
				autoClose: 5000,
			}
		);
	}, []);

	useEffect(() => {
		if(actionPerformed) {
			toastEmitter.update(toastReference.current,
				{
					autoClose: 2000,
					render: renderToast()
				}
			);
		}
	}, [actionPerformed]);

	function renderToast() {
		return (
			<div
				className='toast_content'
				id={toastId}
			>
				<div>
					{actionPerformed ? action.afterClickContent : children}
				</div>
				{!actionPerformed &&
				<div className='button_container'>
					<Button
						onClick={toastActionClickedInnerFunction}
						flat
					>
						{action.content}
					</Button>
				</div>
				}
			</div>
		);
	}

	const completed = () => {
		updateDismissed(true);
		onDismiss();
	};

	return null;
}